<template>
  <div class="wrap-helper-show g-flex-column-sb">
    <div class="back-btn"><el-button size="medium"  @click="$router.push({ path: '/customer/workPlatform' })">返回</el-button></div>
    <div :style="{ height:bannerHeight+'px' }" class="banner" >
      <div class="wrap_left">
        <div class="shopOil g-flex-c"><img src="https://web.nlktj.com/ty/merchant/persisMarket/ye-fire.png" alt="">{{persisGasNum || 2500}}座油站累计参加</div>
        <div class="shop g-flex-c" @click="$router.push({ path: '/vipMarket/vipDraw' })"><span>立即参与</span></div>
        <div class="task" @click="$router.push({ path: '/vipMarket/taskList' })"><span>我的任务 >></span></div>
      </div>
      <div class="wrap_right">
        <img src="https://web.nlktj.com/ty/merchant/persisMarket/vip-inse.png" alt="">
      </div>
    </div>
    <div class="img_banner">
      <div v-for="(item, index) in caseInfo" :key="index">
        <img :src="item.url" alt="">
        <span class="title">{{item.title}}</span>
        <span v-for="(itemWord, index) in item.content" :key="index">{{itemWord}}</span>
      </div>
    </div>
    <Footer/>
    <agreement ref="agreement" :router="'/promotion/daySpecialSign'" :type="7"/>
  </div>
</template>
<script>
import { persisGasNum } from '@/api/marketPromotion'
import agreement from './agreement'
// import mixins from './mixin'
import Footer from './footer'
export default {
  // mixins: [mixins],
  components: {
    Footer,
    agreement
  },
  data() { 
    return {
      persisGasNum: '', // 参加的油站数量
      count: '', // 参与商家数
      bannerHeight: 410,
      page:'care',
      imgPath: '',
      topBanner: 'daybanner.png',
      caseInfo:[
        {
          url: 'https://web.nlktj.com/ty/merchant/persisMarket/vipOne.png',
          title: '复购留存',
          content: ['客户消费次数少？消费一次就走？', '精准营销工具，帮您留住客户', '提高30%+复购率！']
        },
        {
          url: 'https://web.nlktj.com/ty/merchant/persisMarket/vipSec.png',
          title: '流失召回',
          content: ['老客户流失怎么办？', '智能分析客户行为，助您召回流失客户', '让客户再次下单！']
        },
        {
          url: 'https://web.nlktj.com/ty/merchant/persisMarket/vipThird.png',
          title: '兴趣用户转化',
          content: ['如何快速提销量？', '精准锁定海量潜在客户', '定向营销触达，让销量暴增！']
        },
        {
          url: 'https://web.nlktj.com/ty/merchant/persisMarket/vipFour.png',
          title: '数据可视化',
          content: ['如何掌握一手用户数据？', '精准营销可智能分析油站用户数据', '通过可视化工具，拉近您与用户等距离', '真正实现用户精准营销！']
        }
      ]
    } 
  },
  mounted () {
    this.persisGasNumApi()
    this.$track.pageViewEvent('工作台-会员营销-介绍页', '1628747635')
  },
  methods: {
    // 报名跳转
    async persisGasNumApi () {
      const { code, result } = await persisGasNum() // 7-天天特价 8-加油送水 9-限时秒杀
      if(code !== 200) return
      this.persisGasNum = result
    }
    // setSize () {
    //   // 通过浏览器宽度(图片宽度)计算高度
    //   if(this.screenWidth < 1080) return
    //   this.bannerHeight = 420 / 1920 * this.screenWidth;
    // }
  }
}
</script>
<style lang="less" scoped>
.wrap-helper-show{
  width: 100%;
  min-width: 1100px;
  padding: 10px 0;
  background: #F8F9FD;
}
.back-btn{
  width: 100%;
  margin: 0 0 10px 0;
  padding: 10px 0;
  background: #fff;
  margin-top: 10px;
  box-shadow: 0px 2px 2px 0px rgba(215, 215, 215, 0.4);
  border-radius: 1px;
  .el-button{
    width: 120px;
    height: 40px;
  }
}
.banner{
  margin: 10px 0 20px 0;
  background: #fff;
  width: 100%;
  position: relative;
  background-size: 100%!important;
  display: flex;
  justify-content: space-between;
  .wrap_left {
    min-width: 527px;
    padding: 40px;
    background: url('https://web.nlktj.com/ty/merchant/persisMarket/vip-showBanner.png') no-repeat;
    background-size: 100% 100%;
  }
  .wrap_right {
    flex:1;
    padding: 20px 60px 20px 5px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    >img{
      display: block;
      width: 515px;
      height: 343px;
    }
  }
  .shop{
    position: absolute;
    width: 120px;
    height: 38px;
    background: #FFFFFF;
    border-radius: 4px;
    top: 68%;
    left: 70px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #296DD1;
    cursor: pointer;
    >img{
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .shopOil{
    position: absolute;
    top: 60%;
    left: 70px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #D4E1F5;;
    >img{
      display: block;
      width: 12px;
      height: 16px;
      margin-right: 10px;
    }
  }
  .task{
    position: absolute;
    top: 83%;
    left: 70px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }
}
.img_banner{
  width: 100%;
  height: 296px;
  margin-bottom: 20px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  >div{
    width: 24%;
    height: 280px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    >img{
      display: block;
      width: 102px;
      height: 102px;
    }
    >span{
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .title{
      margin-bottom: 10px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
}
</style>